import React, { FunctionComponent, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { IDateTimeInputProps } from './types';

import { get } from 'lodash';
import ReactDatePicker from 'react-datepicker';

/**
 * This DateTimeInput field is specific for AnnualsForm.
 * For any other form please use the general DateTimeInput component
 */
export const AnnualFormDateTimeInput: FunctionComponent<IDateTimeInputProps> = ({
  id,
  name,
  defaultValue,
  placeholder,
  validation,
  label,
  value,
  yearPicker,
  minDate,
  maxDate,
  selected,
  ...props
}) => {
  const { control, errors, setValue } = useFormContext();

  useEffect(() => {
    if (value) {
      setValue(name, new Date(value));
    }
  }, [value, name, setValue]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      rules={validation}
      render={(controllerProps) => {
        const finalValue = controllerProps.value.date ? controllerProps.value.date : controllerProps.value;

        return (
          <>
            {!!get(errors, name, false) && (
              <label htmlFor={name} style={{ color: 'red' }}>
                {`${label ? label + ' - ' : ''} ${get(errors, `${name}.message`)}`}
              </label>
            )}
            {!get(errors, name, false) && <label htmlFor={name}>{label}</label>}
            {yearPicker ? (
              <ReactDatePicker
                {...props}
                selected={finalValue}
                id={id}
                name={name}
                onChange={controllerProps.onChange}
                value={finalValue}
                showYearPicker
                dateFormat={'yyyy'}
                autoComplete="off"
                minDate={minDate}
                maxDate={maxDate}
              />
            ) : (
              <ReactDatePicker
                {...props}
                selected={finalValue}
                id={id}
                name={name}
                onChange={(date) => {
                  controllerProps.onChange(date);
                  setValue(name, date);
                }}
                autoComplete="off"
                minDate={minDate}
                maxDate={maxDate}
              />
            )}
          </>
        );
      }}
    />
  );
};
